/* AZFindings global scripts – vanilla, dependency-free */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var format = (window.AZ && window.AZ.moneyFormat) || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
  }
  window.AZFormatMoney = formatMoney;

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-menu-open]');
    var closeBtn = e.target.closest('[data-menu-close]');
    var nav = $('[data-site-nav]');
    if (!nav) return;
    if (openBtn) { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (closeBtn || (nav.classList.contains('is-open') && e.target.closest('[data-site-nav] a'))) {
      nav.classList.remove('is-open'); document.body.style.overflow = '';
    }
  });

  /* ---------- Search drawer ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      var d = $('[data-search-drawer]');
      if (d) { d.classList.add('is-open'); var input = $('input[type="search"]', d); if (input) setTimeout(function(){ input.focus(); }, 120); }
    }
    if (e.target.closest('[data-search-close]')) {
      var dd = $('[data-search-drawer]'); if (dd) dd.classList.remove('is-open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = $('[data-search-drawer]'); if (d) d.classList.remove('is-open');
      closeCart();
      $$('.az-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
      var nav = $('[data-site-nav]'); if (nav) nav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Modals ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var m = document.getElementById(opener.getAttribute('data-modal-open'));
      if (m) m.classList.add('is-open');
    }
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('az-modal__backdrop')) {
      var open = e.target.closest('.az-modal'); if (open) open.classList.remove('is-open');
    }
  });

  /* ---------- Cart drawer ---------- */
  function openCart() {
    var root = $('[data-cart-drawer-root]');
    if (root) { root.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeCart() {
    var root = $('[data-cart-drawer-root]');
    if (root) { root.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  window.AZOpenCart = openCart;

  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer-root]');
        var current = $('[data-cart-drawer-root]');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen || openAfter) openCart();
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.setAttribute('data-count', cart.item_count);
          });
        });
      });
  }
  window.AZRefreshCart = refreshCartDrawer;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      var useDrawer = document.body.hasAttribute('data-cart-drawer-disabled') === false;
      if (useDrawer) { e.preventDefault(); openCart(); }
    }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('drawer-backdrop')) closeCart();

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.getAttribute('data-cart-remove'), 0);
    }
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn && qtyBtn.hasAttribute('data-line-key')) {
      e.preventDefault();
      var input = qtyBtn.parentElement.querySelector('input');
      var next = parseInt(input.value, 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      if (next < 0) next = 0;
      changeLine(qtyBtn.getAttribute('data-line-key'), next);
    } else if (qtyBtn) {
      var inp = qtyBtn.parentElement.querySelector('input');
      var v = parseInt(inp.value, 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      if (v < 1) v = 1;
      inp.value = v;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function changeLine(key, qty) {
    fetch(window.AZ.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCartDrawer(false); });
  }

  /* AJAX add-to-cart for any product form marked data-ajax-cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = '…'; }
    fetch(window.AZ.routes.cart_add_url + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return refreshCartDrawer(true); })
      .catch(function () { window.location.href = window.AZ.routes.cart_url; })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label'); }
      });
  });

  /* ---------- Collection filters: auto-submit ---------- */
  var filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]')) {
      var w = $('[data-filters-wrapper]'); if (w) w.classList.toggle('is-open');
    }
  });
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Recently viewed (localStorage) ---------- */
  var KEY = 'az-recently-viewed';
  window.AZTrackProduct = function (handle) {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* private mode */ }
  };
  window.AZRenderRecentlyViewed = function (container, excludeHandle, max) {
    var list;
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== excludeHandle; }).slice(0, max || 4);
    if (!list.length) { var s = container.closest('.recently-viewed-section'); if (s) s.style.display = 'none'; return; }
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (p) {
          var card = document.createElement('a');
          card.className = 'product-card';
          card.href = p.url;
          var img = p.featured_image ? '<img src="' + p.featured_image + '&width=420" loading="lazy" alt="">' : '';
          if (p.featured_image && p.featured_image.indexOf('?') === -1) img = '<img src="' + p.featured_image + '?width=420" loading="lazy" alt="">';
          card.innerHTML =
            '<div class="product-card__media">' + img + '</div>' +
            '<div class="product-card__info"><span class="product-card__title">' + p.title + '</span>' +
            '<span class="product-card__price">' + formatMoney(p.price) + '</span></div>';
          container.appendChild(card);
        })
        .catch(function () {});
    });
  };

  /* ---------- Newsletter inline success ---------- */
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    var nl = $('[data-newsletter-success]');
    if (nl) { nl.hidden = false; var f = $('.newsletter-form'); if (f) f.hidden = true; }
  }
})();
